module.exports = __webpack_public_path__ + "static/img/44.94d71419.png";